export enum AddressType {
  IncorporationAddress = 0,
  TradingAddress = 1,
}
